import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Typography } from '@mui/material';

import { ShiftInstance } from 'src/store/sageAdminApi';
import { formatShiftTime } from 'src/utils/timeUtils';

interface ShiftCardProps {
    shift: ShiftInstance;
}

export default function ShiftCard(props: ShiftCardProps) {
    const { shift } = props;

    return (
        <Stack sx={{ gap: 0.5 }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                {shift.name}
            </Typography>

            <Stack direction="row" sx={{ alignItems: 'center', gap: 1.5, color: 'grey.700' }}>
                <FontAwesomeIcon icon={faClock} />
                <Typography variant="body1">
                    {formatShiftTime(shift.startTimeMs, shift.endTimeMs)}
                </Typography>
            </Stack>
        </Stack>
    );
}
